var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuteLadybug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CC0000",
    d: "M432.713,317.8c-1.675-17.868-6.008-34.973-12.602-50.917l62.12-35.864l-16.696-28.917l-61.051,35.247 c-12.521-19.072-28.61-35.595-47.315-48.619c1.429-6.89,2.157-13.923,2.157-21.029c0-37.173-19.735-69.82-49.275-88.025 c4.755-29.137,29.088-57.354,29.361-57.666L314.301,0c-1.306,1.487-27.017,31.151-35.642,66.885 c-7.295-1.638-14.877-2.509-22.659-2.509c-7.782,0-15.364,0.87-22.659,2.509C224.716,31.151,199.005,1.487,197.699,0 l-25.091,22.033c7.415,8.445,25.279,33.405,29.319,57.659c-29.528,18.208-49.252,50.848-49.252,88.01 c0,7.106,0.728,14.139,2.157,21.029c-18.706,13.023-34.795,29.547-47.315,48.619l-61.051-35.247l-16.696,28.917l62.12,35.864 c-6.594,15.944-10.927,33.049-12.602,50.917H6.516v33.391h72.771c1.675,17.868,6.008,34.972,12.602,50.916l-62.12,35.865 l16.696,28.917l61.051-35.248c31.744,48.356,86.443,80.358,148.484,80.358s116.74-32.002,148.484-80.358l61.051,35.248 l16.696-28.917l-62.119-35.865c6.594-15.944,10.927-33.048,12.601-50.916h72.772v-0.001V317.8H432.713z M239.305,477.635 c-71.628-8.301-127.418-69.322-127.418-143.139c0-73.818,55.79-134.839,127.418-143.142V477.635z M272.696,477.636V191.355 c71.628,8.301,127.418,69.323,127.418,143.142C400.113,408.312,344.323,469.334,272.696,477.636z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CC0000",
    cx: 199.179,
    cy: 273.597,
    r: 17.653
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CC0000",
    cx: 158.342,
    cy: 334.491,
    r: 17.653
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CC0000",
    cx: 199.179,
    cy: 395.386,
    r: 17.653
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CC0000",
    cx: 312.821,
    cy: 273.597,
    r: 17.653
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CC0000",
    cx: 353.658,
    cy: 334.491,
    r: 17.653
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CC0000",
    cx: 312.821,
    cy: 395.386,
    r: 17.653
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuteLadybug);
export default __webpack_public_path__ + "static/media/cute_ladybug.3efd49bc2c665ba5d8016b30d47656b6.svg";
export { ForwardRef as ReactComponent };